function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectSeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M45.001 29.866c0 3.586-2.878 6.493-6.429 6.493H15.43C11.88 36.36 9 33.452 9 29.866V6.492C9.001 2.906 11.879 0 15.43 0h23.142c3.55 0 6.429 2.907 6.429 6.493v23.374z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.857 36.378V18.18H54v18.263c0 2.478-1.732 4.119-3.343 5.1-1.676 1.02-3.89 1.765-6.29 2.32-4.841 1.12-11.163 1.622-17.383 1.584-6.222-.037-12.534-.617-17.362-1.752-2.392-.563-4.588-1.3-6.248-2.279C1.825 40.503 0 38.916 0 36.443V18.18h5.143v18.116c.074.098.286.317.825.635 1.012.597 2.632 1.19 4.82 1.705 4.333 1.019 10.235 1.58 16.227 1.617 5.994.036 11.887-.455 16.206-1.453 2.18-.505 3.784-1.099 4.78-1.705.617-.376.806-.626.856-.717zm.016-.037s-.001.008-.009.023c.004-.016.008-.023.009-.023zM5.107 36.24s.004.005.008.016a.055.055 0 01-.008-.016z",
    fill: props.fill
  }));
}
export default SvgSelectSeat;